export enum ReferrerType {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export const NotAvailableReferrerCountryCodes: string[] = ['Ukraine', 'India'];
